export type PasswordValidationRule = {
  id: string;
  label: string;
  isValid: boolean;
};

export type PasswordValidationResult = {
  rules: PasswordValidationRule[];
  isAllValid: boolean;
};

const MIN_LENGTH = 6;
const SPECIAL_CHARACTERS_REGEX = /[@!%#&;£$^*{},.]/;
const CONTAINS_NUMBER_REGEX = /\d/;
const CONTAINS_LETTER_REGEX = /[a-zA-Z]/;

export const hasMinLength = (password: string): boolean => password.length >= MIN_LENGTH;

export const hasLetter = (password: string): boolean => CONTAINS_LETTER_REGEX.test(password);

export const hasNumber = (password: string): boolean => CONTAINS_NUMBER_REGEX.test(password);

export const hasSpecialCharacter = (password: string): boolean => SPECIAL_CHARACTERS_REGEX.test(password);

export const validatePassword = (
  password: string,
  ruleLabels: {
    hasLetter: string;
    hasNumber: string;
    hasSpecialChar: string;
    minLength: string;
  },
): PasswordValidationResult => {
  const rules: PasswordValidationRule[] = [
    {
      id:      'hasLetter',
      label:   ruleLabels.hasLetter,
      isValid: hasLetter(password),
    },
    {
      id:      'hasNumber',
      label:   ruleLabels.hasNumber,
      isValid: hasNumber(password),
    },
    {
      id:      'hasSpecialChar',
      label:   ruleLabels.hasSpecialChar,
      isValid: hasSpecialCharacter(password),
    },
    {
      id:      'minLength',
      label:   ruleLabels.minLength,
      isValid: hasMinLength(password),
    },
  ];

  const isAllValid = rules.every((rule) => rule.isValid);

  return {
    rules,
    isAllValid,
  };
};

export const isPasswordValid = (password: string): boolean => (
  hasMinLength(password) &&
    hasLetter(password) &&
    hasNumber(password) &&
    hasSpecialCharacter(password)
);

export default validatePassword;
